import { CurrencyExchange } from "@/modules/transaction/components";
import type { IOperationPageProps } from "@/shared/common/types";

export const CurrencyExchangePage = ({ isCopy, isEdit }: IOperationPageProps) => (
  <CurrencyExchange isCopy={isCopy} isEdit={isEdit}/>
);
